import { Routes } from '@angular/router';
import { LoginComponent } from 'app/manage/components/login/login.component';
import { PageNotFoundComponent } from 'app/shared/components/page-not-found/page-not-found.component';
import { authGuard } from 'guards/auth.guard';
import { StyleDevComponent } from './components/style-dev/style-dev.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: LoginComponent,
  },
  {
    path: 'administration',
    loadChildren: () =>
      import('./administration/administration-routing.module').then((m) => m.routes),
    canActivate: [authGuard],
    data: {
      requiredPermissions: {
        some: ['Administration.FullAccess', 'Administration.ReadOnly'],
      },
    },
  },
  // Note that if you have too many paths matching '' in submodules then
  // relative routing doesn't work as expected. So for now having this under a path
  // that isn't '' seems strange. When we've added more modules such as settings
  // or users then this will fit better.
  {
    path: 'manage',
    loadChildren: () => import('./manage/manage-routing.module').then((m) => m.routes),
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user-routing.module').then((m) => m.routes),
  },
  {
    path: 'dev/style',
    component: StyleDevComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
